// extracted by mini-css-extract-plugin
export default {"authors":"authors_authors__ONJqw","editor":"authors_editor__2wZrI","editable":"authors_editable__EUY5r"};